import { Button, Column, Row } from 'hatch-components';
import styled from 'styled-components';

export const DRAWER_WIDTH = 415;

export const StyledDrawer = styled(Column)(
  ({
    transition,
    theme: {
      colors,
      responsive: { mobile },
    },
  }) => ({
    background: colors.white,
    bottom: 0,
    height: '100%',
    [mobile]: {
      transform: `translateX(${transition === 'entered' ? 0 : '100vw'})`,
      width: '100%',
    },
    position: 'fixed',
    right: 0,
    transform: `translateX(${
      transition === 'entered' ? 0 : `${DRAWER_WIDTH}px`
    })`,
    transition: 'transform 0.25s ease',
    width: DRAWER_WIDTH,
    zIndex: 9999,
  }),
);

export const StyledDrawerHeader = styled(Row)(
  ({
    theme: {
      spacing,
      responsive: { mobile },
    },
  }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: `${spacing.md} ${spacing.md} ${spacing.md} ${spacing.md}`,
    [mobile]: {
      margin: `${spacing.md} ${spacing.md} ${spacing.md} 16px`, // spacing is for off-sized back arrow SVG
      width: `calc(100% - ${spacing.md} - 16px)`,
    },
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);

export const StyledTitle = styled.h1(
  ({
    theme: {
      font,
      colors,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    color: colors.black,
    fontSize: font.size.md,
    fontWeight: font.weight.bold,
    height: font.lineHeight.md,
    lineHeight: font.lineHeight.md,
    [mobile]: {
      paddingLeft: spacing.sm,
      width: `calc(100% - ${spacing.sm})`,
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);

export const StyledHeaderLeftWrapper = styled(Row)(
  ({
    theme: {
      spacing,
      responsive: { mobile },
    },
  }) => ({
    flexWrap: 'nowrap',
    [mobile]: {
      paddingLeft: spacing.sm,
      width: `calc(100% - ${spacing.sm})`,
    },
    overflow: 'hidden',
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);

export const StyledCloseButton = styled(Button)(
  ({
    showOnMobile,
    theme: {
      colors,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    '&:hover': {
      svg: {
        'path, line': {
          stroke: colors.darkGrey,
        },
      },
    },
    display: showOnMobile ? 'none' : 'flex',
    height: spacing.md,
    [mobile]: {
      display: showOnMobile ? 'flex' : 'none',
    },
    padding: 0,
    svg: {
      margin: 0,
    },
    width: spacing.md,
  }),
);
